/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
import { Button, Input, Select, Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant";
import { getFormatedUserType } from "@/utils/userTypeFomater";
import RecipientListTable from "./RecipientListTable";
import { flare } from "@flareapp/js";

const RecipientList = () => {
  const userDetails = useSelector((state) => state?.user?.userDetails);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [siteLocations, setSiteLocations] = useState([]);
  const [siteLocationsEx, setSiteLocationsEx] = useState([]);
  const [assignedAlarm, setAssignedAlarm] = useState([]);
  const [users, setUsers] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [notificationsEx, setNotificationsEx] = useState([]);
  const [assignAlerm, setAssignAlarm] = useState({});
  const [AssignAlarmEx, setAssignAlarmEx] = useState({
    isActive: true,
  });
  const [businessList, setBusinessList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [sendAllEmailToSuper, setSendAllEmailToSuper] = useState(false);

  // console.log({ sendAllEmailToSuper });

  // const onChangeSendAllEmailToSuper = async (e) => {
  //   try {
  //     const checked = e.target.checked;
  //     setSendAllEmailToSuper(checked);
  //     await api.put(endpoint.update_user_details, { sendAllEmailToSuper: checked });
  //   } catch (error) {
  // flare.report(error);
  //     // eslint-disable-next-line no-console
  //     console.log(error);
  //   }
  // };
  const getSuperAdmin = async () => {
    // this is hadcoded super admin
    const response = await axios.get(`/user/` + "65614aeec83b1f26364ef72b", { withCredentials: true });
    if (response) {
      setSendAllEmailToSuper(response?.data?.sendAllEmailToSuper);
    }
  };

  const getBusiness = async () => {
    try {
      const data = await api.get(endpoint?.business);
      setBusinessList(data?.data);
      if (Array.isArray(data?.data) && data.data.length === 1) {
        setAssignAlarmEx({ ...AssignAlarmEx, business: data.data[0]._id });
        setAssignAlarm({ ...assignAlerm, business: data.data[0]._id });
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business list", error);
    }
  };

  const onInputChangeEx = (e) => {
    setAssignAlarmEx({ ...AssignAlarmEx, [e.target.name]: e.target.value });
  };

  const handleUserChange = (ids) => {
    let user = users.filter((item) => ids.some((innerItem) => innerItem === item._id));
    setAssignAlarm({
      ...assignAlerm,
      user,
    });
  };

  const getSiteLocations = async () => {
    try {
      const response = await axios.get(`/site-location/my-site`, {
        params: { business: assignAlerm?.business ? [assignAlerm?.business] : "", limit: 100000 },
        withCredentials: true,
      });
      setSiteLocations(response.data);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };

  const getSiteLocationsEx = async () => {
    try {
      const response = await axios.get(`/site-location/my-site`, {
        params: { business: AssignAlarmEx?.business ? [AssignAlarmEx?.business] : "", limit: 100000 },
        withCredentials: true,
      });
      setSiteLocationsEx(response.data);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };

  const getNotifications = async () => {
    try {
      const response = await axios.get(endpoint.notification, {
        params: { site: assignAlerm?.site, page: 1, limit: 99999 },
        withCredentials: true,
      });
      setNotifications(response.data?.results);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };

  useEffect(() => {
    if (assignAlerm?.site) {
      getNotifications();
    }
  }, [assignAlerm?.site]);

  const getNotificationsEx = async () => {
    axios
      .get(endpoint.notification, {
        params: { site: AssignAlarmEx?.site, page: 1, limit: 99999 },
        withCredentials: true,
      })
      .then((res) => setNotificationsEx(res.data?.results));
  };
  useEffect(() => {
    if (AssignAlarmEx?.site) {
      getNotificationsEx();
    }
  }, [AssignAlarmEx?.site]);
  const getUsers = async () => {
    if (!assignAlerm?.site) {
      setUsers([]);
      return;
    }
    try {
      const response = await axios.get(`/user/include-me`, {
        withCredentials: true,
        params: {
          limit: 10000,
          page: 1,
          site: assignAlerm?.site,
          role: assignAlerm.role,
        },
      });
      setUsers(response.data.results);
    } catch {
      setUsers([]);
    }
  };
  useEffect(() => {
    if (assignAlerm?.role !== "external") {
      getUsers();
    }
  }, [assignAlerm?.site, assignAlerm?.role]);

  const getAssignedAlarm = async () => {
    setIsTableLoading(true);
    try {
      const response = await axios.get(`/notification/assign`, {
        withCredentials: true,
        params: { searchText, unknown: true },
      });
      setAssignedAlarm(response.data);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }

    setIsTableLoading(false);
  };
  useEffect(() => {
    document.title = appConfig.name + " - Recipient List";
    getAssignedAlarm();
  }, [searchText]);

  useEffect(() => {
    getBusiness();
    getSuperAdmin();
  }, []);

  useEffect(() => {
    getSiteLocations();
    getSiteLocationsEx();
  }, [userDetails, assignAlerm?.business]);

  useEffect(() => {
    getSiteLocations();
    getSiteLocationsEx();
  }, [userDetails, AssignAlarmEx?.business]);

  const handleSubmitEx = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/notification/assign`, AssignAlarmEx, {
        withCredentials: true,
      });
      Swal.fire({
        title: "Done!",
        text: "Alarm Assign Successfully",
        icon: "success",
        timer: 2000,
        button: false,
        confirmButtonText: "OK",
      });
      getAssignedAlarm();
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `/notification/assign`,
        {
          data: assignAlerm?.user?.map((user) => ({
            ...assignAlerm,
            user: user._id,
            name: user?.name,
            email: user?.email,
          })),
        },
        {
          withCredentials: true,
        },
      );
      Swal.fire({
        title: "Done!",
        text: "Alarm Assign Successfully",
        icon: "success",
        timer: 2000,
        button: false,
        confirmButtonText: "OK",
      });
      getAssignedAlarm();
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };

  return (
    <div className="settings">
      <div className="card p-3 mb-3">
        <div className="d-flex flex-column flex-md-row g-3 align-items-md-center mb-3 justify-content-between">
          <div>
            <label className="az-content-label">MANAGE NOTIFICATION</label>
            <span className="d-block py-2">Notification Recipient List</span>
          </div>
          <div className="ms-md-auto">
            <Link to="/alarm-summary" className="btn btn-secondary">
              Back
            </Link>
          </div>
        </div>
        <hr className="mt-0" />

        <div className="row mt-3 g-3">
          <div className="col-md-6 border-md-end">
            <h6 className="fw-bold mt-0">Assign Existing System User Accounts</h6>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-4 mt-2">
                  <label htmlFor="business" className="form-label">
                    Business
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    size="large"
                    value={assignAlerm?.business}
                    onChange={(value) =>
                      setAssignAlarm((prev) => {
                        return { ...prev, business: value, site: "", user: [], alarm: "" };
                      })
                    }
                    showSearch={true}
                    disabled={businessList?.length === 1}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    placeholder="Select Business"
                    options={[...businessList.map((item) => ({ label: `${item.name} (${item.id})`, value: item._id }))]}
                    required
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="site" className="form-label">
                    Site Location
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    size="large"
                    value={assignAlerm?.site || undefined}
                    onChange={(value) => setAssignAlarm((prev) => ({ ...prev, site: value }))}
                    placeholder="Select Site"
                    showSearch={true}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    options={[...(siteLocations?.map((item) => ({ label: item.name, value: item._id })) || [])]}
                    required
                  />
                </div>

                <div className="col-md-4 mt-2">
                  <label htmlFor="role" className="form-label">
                    User Type
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    size="large"
                    value={assignAlerm?.role || undefined}
                    onChange={(value) => setAssignAlarm((prev) => ({ ...prev, role: value }))}
                    placeholder="Select User Type"
                    options={Object.keys(userRole)
                      ?.filter(
                        (role, idx) =>
                          role !== userRole.superAdmin || !Object.keys(userRole).indexOf(userDetails?.role) < idx,
                      )
                      .map((role) => ({
                        value: role,
                        label: getFormatedUserType(role),
                      }))}
                    required
                  />
                </div>

                <div className="col-md-4 mt-2">
                  <label htmlFor="user" className="form-label">
                    Site User
                  </label>
                  <Select
                    showSearch={true}
                    style={{ width: "100%" }}
                    size="large"
                    filterOption={(input, option) =>
                      (option?.children ? option?.children.toLowerCase() : "").includes(input?.toLowerCase())
                    }
                    onChange={handleUserChange}
                    value={assignAlerm?.user?.length ? assignAlerm?.user.map((item) => item._id) : []}
                    placeholder="Select User"
                    mode="multiple"
                  >
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <Select.Option value={item._id} key={index}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="user" className="form-label">
                    Alarm Name
                  </label>
                  <Select
                    showSearch={true}
                    style={{ width: "100%" }}
                    size="large"
                    filterOption={(input, option) =>
                      (option?.children ? option?.children.toLowerCase() : "").includes(input?.toLowerCase())
                    }
                    onChange={(value) => setAssignAlarm((prev) => ({ ...prev, alarm: value }))}
                    value={assignAlerm?.alarm || undefined}
                    placeholder="Select Alarm"
                  >
                    {notifications &&
                      notifications.length > 0 &&
                      notifications.map((item, index) => (
                        <Select.Option value={item._id} key={index}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </div>

                <div className="col-md-12">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="mt-3 float-end"
                    disabled={!assignAlerm?.role || !assignAlerm?.user || !assignAlerm?.alarm}
                  >
                    Assign
                  </Button>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-6">
            <h6 className="fw-bold mt-0">Assign Email Address (External Accounts)</h6>
            <form onSubmit={handleSubmitEx}>
              <div className="row">
                <div className="col-md-4 mt-2">
                  <label htmlFor="business" className="form-label">
                    Business
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    size="large"
                    id="business"
                    name="business"
                    value={AssignAlarmEx?.business}
                    onChange={(value) =>
                      setAssignAlarmEx((prev) => {
                        return { ...prev, business: value, site: "", user: "", email: "", name: "", alarm: "" };
                      })
                    }
                    showSearch={true}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    placeholder="Select Business"
                    disabled={businessList?.length === 1}
                    options={[...businessList.map((item) => ({ label: `${item.name} (${item.id})`, value: item._id }))]}
                    required
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="site" className="form-label">
                    Site Location
                  </label>

                  <Select
                    showSearch={true}
                    style={{ width: "100%" }}
                    size="large"
                    filterOption={(input, option) =>
                      (option?.children ? option?.children.toLowerCase() : "").includes(input?.toLowerCase())
                    }
                    onChange={(value) => setAssignAlarmEx((prev) => ({ ...prev, site: value }))}
                    value={AssignAlarmEx?.site || undefined}
                    placeholder="Select Site"
                  >
                    {siteLocationsEx?.length &&
                      siteLocationsEx.map((item, index) => (
                        <Select.Option value={item._id} key={index}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="name" className="form-label">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder="Enter full name"
                    onChange={onInputChangeEx}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="Enter email"
                    onChange={onInputChangeEx}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="alarm" className="form-label">
                    Alarm Name
                  </label>
                  <Select
                    showSearch={true}
                    style={{ width: "100%" }}
                    size="large"
                    filterOption={(input, option) =>
                      (option?.children ? option?.children.toLowerCase() : "").includes(input?.toLowerCase())
                    }
                    onChange={(value) => setAssignAlarmEx((prev) => ({ ...prev, alarm: value }))}
                    value={AssignAlarmEx?.alarm || undefined}
                    placeholder="Select Alarm"
                  >
                    {notificationsEx &&
                      notificationsEx.length > 0 &&
                      notificationsEx.map((item, index) => (
                        <Select.Option value={item._id} key={index}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </div>
                <div className="col-md-12">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="mt-3 float-end"
                    disabled={
                      !AssignAlarmEx?.site || !AssignAlarmEx?.name || !AssignAlarmEx?.email || !AssignAlarmEx?.alarm
                    }
                  >
                    Assign
                  </Button>
                </div>
              </div>
            </form>
          </div>
          {/* <div className="col-12">
            {userDetails?.role === userRole.superAdmin && (
              <div className="col-md-12">
                <Checkbox checked={sendAllEmailToSuper} onChange={onChangeSendAllEmailToSuper}>
                  Get Notified of All Alarms Via Email and App
                </Checkbox>
              </div>
            )}
          </div> */}
        </div>

        <hr />
        <div className="row">
          <div className="col-md-10"></div>
          <div className="col-md-2">
            <Input
              type="search"
              size="large"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search"
              // className="me-2"
              aria-label="Search"
            />
          </div>
        </div>
        <Spin spinning={isTableLoading}>
          <RecipientListTable data={assignedAlarm} getAssignedAlarm={getAssignedAlarm} siteLocations={siteLocations} />
        </Spin>
      </div>
    </div>
  );
};

export default RecipientList;
